import { DrupalMenuLinkContent } from "next-drupal"


export function formatDate(input: string): string {
    const date = new Date(input)
    return date.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    })
  }
  
// export function absoluteUrl(input: string) {
//   return `${process.env.NEXT_PUBLIC_DRUPAL_BASE_URL}${input}`
// }


export function makeDrupalMenuLinkContent(props: any): DrupalMenuLinkContent {
    return {
      title: props.title ?? 'Home',
      description: props.description ?? '',
      enabled: true,
      expanded: false,
      id: props.id ?? props.title.toLowerCase().replace('/ /_/'),
      menu_name: '',
      meta: {},
      options: {},
      parent: '',
      provider: '',
      route: props.route ?? {
          name: '',
          parameters: {}
      },
      type: '',
      url: props.url ?? '/',
      weight: '0',
      items: props.items ?? []
  }
}